module.exports = __webpack_public_path__ + "img/shopping_basket.7e4dfbc4.svg";